"use strict";

import React from 'react';
import defaultState from '../store/register-initial-state';
import { RegisterProvider as Provider } from "../context/RegisterContext";
import axios from "../utilities/axiosEcheckWrapper";
import emailExists from "../../emailExists";
import {withAlert} from "react-alert";
import {withRouter} from "react-router-dom";

class RegisterProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = defaultState;
        this.emailIsUnique = this.emailIsUnique.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.setPassword = this.setPassword.bind(this);
        this.setBillingDetails = this.setBillingDetails.bind(this);
        this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
        this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);
        this.handleBillingDetailsSubmit = this.handleBillingDetailsSubmit.bind(this);
        this.validateEmailData = this.validateEmailData.bind(this);
        this.validatePasswordData = this.validatePasswordData.bind(this);
        this.validateBillingDetailsData = this.validateBillingDetailsData.bind(this);
        this.validateSteps = this.validateSteps.bind(this);
        this.goToPreviousStep = this.goToPreviousStep.bind(this);
        this.setCurrentStep = this.setCurrentStep.bind(this);
        this.getCurrentStep = this.getCurrentStep.bind(this);
        this.createAccount = this.createAccount.bind(this);
    }

    componentDidMount() {}

    emailIsUnique(email=''){
        return new Promise((resolve, reject) => {
            if (!!email) {
                this.setState(()=>{return {isFindingEmail: true,};});
                emailExists(email).then((response) => {
                    reject(0);
                }).catch((error) => {
                    resolve(1);
                }).finally(()=>{
                    this.setState(()=>{return {isFindingEmail: false,};});
                });
            }
        });
    }

    handleEmailSubmit(data={}){
        if(!!data && !!data.email)
            this.setEmail(data.email);
    }

    handlePasswordSubmit(data={}){
        if(!!data && !!data.password)
            this.setPassword(data.password);
    }

    handleBillingDetailsSubmit(data={}){
        if(!!data){
            this.setBillingDetails(data);
        }
    }

    createAccount(){
        return new Promise((resolve, reject)=>{
            if(this.getCurrentStep() !== 3){
                const message = `Could not create an account. Not all registration steps have been completed.`;
                this.props.error(message);
                reject(message);
            }
            const {email, password, billingDetails} = this.state;
            const [zip = '', zip5 = '', zip4 = ''] = billingDetails.zip.match(/^(\d{5})-?(\d{4})?$/);
            const phone = billingDetails.phone.replace(/[^\d]/g, '');

            const data={
                ...billingDetails,
                ...{ email: email,
                     password: password,
                     zip5: zip5,
                     zip4: zip4,
                     phone: phone,
                },
            }
            delete data.zip;
            this.setState(()=>{return {isCreatingAccount: true,};});
            axios.post(`echecks/register`, data)
                .then((response) => {
                    this.setState(()=>{return {isCreatingAccount: false,};});
                    this.setState(()=>{return {isAccountCreated: true,};});
                    this.props.alert.success('Your E-check account has been created', {
                        onOpen: () => {
                            window.location = window.location.origin + '/echeck/accounts';
                            resolve(data);
                        },
                    });
                })
                .catch((error) => {
                    const message = `Error: ${error.data.message || ''}`;
                    this.props.alert.error(message);
                    reject(message);
                }).finally(()=>{
                    this.setState(()=>{return {isCreatingAccount: false,};});
                });
        });
    }

    setEmail(email=''){
        this.setState(()=>{
            return {email: email, editStep: null,};
        }, ()=>{this.validateSteps();});
    }

    setPassword(password=''){
        this.setState(()=>{
            return {password: password, editStep: null,};
        }, ()=>{this.validateSteps();});
    }

    setBillingDetails(data= {}){
        this.setState(()=>{
            return {billingDetails: {...data}, editStep: null,};
        }, ()=>{this.validateSteps();});
    }

    validateEmailData(email=''){
        return !!email;
    }

    validatePasswordData(password=''){
        return !!password;
    }

    validateBillingDetailsData(data={}){
        return !!data.f_name
            && !!data.l_name
            && !!data.address
            && !!data.city
            && !!data.state
            && !!data.zip
            && !!data.phone
            && !!data.location_class;
    }

    validateSteps(){
        const isValid = {...this.state.isValid};
        const {email='', password='', billingDetails={}} = this.state;
        isValid.step1 = this.validateEmailData(email);
        isValid.step2 = this.validatePasswordData(password);
        isValid.step3 = this.validateBillingDetailsData(billingDetails);
        this.setState({isValid: isValid}, ()=>{this.setCurrentStep();});
    }

    setCurrentStep(){
        this.setState({currentStep: this.getCurrentStep()});
    }

    goToPreviousStep(){
        const currentStep = this.getCurrentStep();
        if(currentStep > 0 && currentStep <= 3 ){
            this.setState(()=>{
                return {editStep: currentStep - 1,};
            }, ()=>{ this.setCurrentStep()});
        }
    }

    getCurrentStep(){
        const {isValid, editStep} = this.state;
        switch (true) {
            case !isValid.step1 || editStep === 0:
                return 0;
            case !isValid.step2 || editStep === 1:
                return 1;
            case !isValid.step3 || editStep === 2:
                return 2;
            case isValid.step1
            && isValid.step2
            && isValid.step3:
                return 3;
            default:
                return 0;
        }
    }

    render() {
        return (
            <Provider value={{
                ...this.state,
                emailIsUnique: this.emailIsUnique,
                handleEmailSubmit: this.handleEmailSubmit,
                handlePasswordSubmit: this.handlePasswordSubmit,
                handleBillingDetailsSubmit: this.handleBillingDetailsSubmit,
                createAccount: this.createAccount,
                goToPreviousStep: this.goToPreviousStep,
            }}> {this.props.children}</Provider>);
    }
}

export default withAlert()(withRouter(RegisterProvider));
